// extracted by mini-css-extract-plugin
export default {"container":"product-list-card__container___3e7Ww"};